import {Component, Input} from '@angular/core';

@Component({
    selector: 'horizontal-spinner',
    templateUrl: './horizontal-spinner.component.html'
})
export class HorizontalSpinnerComponent {

	@Input()
	color: string;

	@Input()
	displaying: string;

	getItemColor() {
		return (this.color) ? this.color : 'black';
	}

	getItems() {
		let numbers: number[] = [1, 2, 3];
		return numbers;
	}

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/spinners/horizontal-spinner.component.ts